// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ResetPassword_wrapper__xhXz1","link":"ResetPassword_link__1acpC","error":"ResetPassword_error__11245","textWrapper":"ResetPassword_textWrapper__70u3x"};